import styled from 'styled-components';

export const Container = styled.div`
  margin: 0;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};

  .title-page {
    font-weight: 450;
    font-size: 30px;
    color: ${({ theme }) => theme.colors.secondary};
    text-align: left;
    padding: 1.5rem 1.9rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: 2rem;

  a {
    color: ${({ theme }) => theme.colors.tertiary_500};
  }

  span {
    text-align: left;
    color: ${({ theme }) => theme.colors.secondary};
  }

  .buttonDiv {
    width: 75%;
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;

    @media (max-width: 660px) {
      width: 70%;
      justify-content: center;
      margin: 1rem auto;
    }
  }
  .containerPolicy {
    display: flex;
    justify-content: flex-end;
    width: 77%;

    .policyDiv {
      display: flex;
      justify-content: flex-end;
      gap: 0.5rem;
      font-size: 14px;
      font-weight: bold;
      margin: 1.5rem;
      flex-direction: column;
      button {
        font-weight: bold;
        color: ${({ theme }) => theme.colors.primary};
        border: none;
      }

      @media (max-width: 660px) {
        justify-content: center;
        width: 80%;
        margin: 1.5rem auto;
      }
    }
  }
`;

export const Form = styled.div`
  .formDiv {
    width: 45%;

    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    background: ${({ theme }) => theme.colors.background_white};
    margin: auto;

    box-shadow: 0px 3px 6px #00000029;
    border-radius: 13px;

    padding: 1.5rem 3rem;
    padding-bottom: 3rem;

    @media (max-width: 1000px) {
      gap: 1rem;
    }

    @media (max-width: 550px) {
      width: 70%;
      padding: 1.5rem 2rem;
    }
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 3rem;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;
